export default {
  statusApproved: 'Aprovada',
  statusBlockedNatura: 'Bloqueada',
  statusDraft: 'Sugerida para início',
  statusGaveup: 'Desistência',
  statusPending: 'Sugerida para início',
  statusRejected: 'Reprovada',
}
